(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["we-floating-filter"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('we-floating-filter')) {
    customElements.define('we-floating-filter', class extends HTMLElement {
      #abort;
      #resize;
      #frame = 0;
      #section;
      connectedCallback() {
        this.#section = this.closest('.shopify-section');
        if (!this.#section) return;
        this.#abort = new AbortController();
        const opts = { signal: this.#abort.signal, passive: true };
        window.addEventListener('scroll', this.#schedule, opts);
        window.addEventListener('resize', this.#schedule, opts);
        window.addEventListener('pageshow', this.#schedule, opts);
        this.#resize = new ResizeObserver(this.#schedule);
        this.#resize.observe(this.#section);
        this.querySelector('button').addEventListener('click', (event) => {
          const drawer = this.#section.querySelector('#filters-drawer');
          if (!drawer || typeof drawer.open !== 'function') return;
          event.currentTarget.focus({preventScroll: true});
          drawer.open();
        }, {signal: this.#abort.signal});
        customElements.whenDefined('theme-drawer').then(this.#schedule);
        this.#schedule();
      }
      #schedule = () => {
        if (this.#frame || !this.isConnected) return;
        this.#frame = requestAnimationFrame(() => {
          this.#frame = 0;
          const grid = this.#section.querySelector('#ResultsList');
          const drawer = this.#section.querySelector('#filters-drawer');
          const bounds = grid?.getBoundingClientRect();
          const ready = typeof drawer?.open === 'function';
          this.toggleAttribute('data-ready', ready);
          if (window.matchMedia('(max-width: 749px)').matches) {
            this.hidden = !ready;
            return;
          }
          const anchor = window.innerHeight - 42;
          this.hidden = !(bounds && typeof drawer?.open === 'function' && grid.querySelector('[data-product-id]') && bounds.top < anchor - 24 && bounds.bottom >= anchor);
        });
      };
      disconnectedCallback() {
        this.#abort?.abort();
        this.#resize?.disconnect();
        cancelAnimationFrame(this.#frame);
        this.#frame = 0;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
